import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=35d0780e&scoped=true"
import script from "./VerifyIdentity.vue?vue&type=script&lang=js"
export * from "./VerifyIdentity.vue?vue&type=script&lang=js"
import style0 from "./VerifyIdentity.vue?vue&type=style&index=0&id=35d0780e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0780e",
  null
  
)

export default component.exports